import React from 'react'
import { Link } from "react-router-dom";

import slider from '../assets/images/slider/slider-lg.jpg';
import slider2 from '../assets/images/slider/slider-lg2.jpg';
import slider3 from '../assets/images/slider/slider-lg3.jpg';
import slider4 from '../assets/images/slider/slider-lg4.jpg';
import slidermb from '../assets/images/slider/slider-mb.jpg';
import slidermb2 from '../assets/images/slider/slider-mb2.jpg';
import slidermb3 from '../assets/images/slider/slider-mb3.jpg';
import slidermb4 from '../assets/images/slider/slider-mb4.jpg';
//
import { Swiper, SwiperSlide } from 'swiper/react';
import {  Autoplay, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";


const SwiperSlider = () => {
 
    return (

    <>

<section className='swiperSection'>

<div className="swiper-button image-swiper-button-next">
        <IoIosArrowForward />
      </div>
      <div className="swiper-button image-swiper-button-prev">
        <IoIosArrowBack />
      </div>

      <Swiper
         pagination={{
          dynamicBullets: true,
          clickable: true,
        }}
        navigation={{
          nextEl: ".image-swiper-button-next",
          prevEl: ".image-swiper-button-prev",
          disabledClass: "swiper-button-disabled"
        }}

        

        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}

        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
      
      <SwiperSlide>

        <div className='swiperWrap'>
        <div className='contentWrap'>   
          <div className='container'>
          <div className='row align-items-center'>
          <div className='col-lg-6 col-md-6 col-9'>
          <h1>We are committed to offering innovative Travel Technology solutions.</h1>
            {/* <p>We are committed to offering innovative Travel Technology solutions that elevate your brand, drive business growth, and foster lasting customer connections.</p> */}
            <Link to='/travel-tourism-b2c' className='get_started mt-2'>Take Off</Link>
            </div>
          </div>
          </div>
          </div>
        </div>     

          <picture>

      <source media="(max-width:576px)" srcSet={slidermb} />
      <img className='img-fluid' src={slider} alt="Flowers"/>
      </picture>

      </SwiperSlide>
 
      <SwiperSlide>

        <div className='swiperWrap'> 
          <div className='contentWrap'>   
          <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-6 col-md-6 col-9'>
            <h1>Driving growth through digital innovation</h1>
            <p>Where strategy meets digital success.</p>
            <Link to='/digital-marketing' className='get_started mt-2'>Get Started</Link>
            </div>
          </div>
          </div>
          </div> 
        </div>     

  <picture>


  <source media="(max-width:576px)" srcSet={slidermb2} />
  <img className='img-fluid' src={slider2} alt="Flowers"/>
</picture>

      </SwiperSlide>

      <SwiperSlide>

        <div className='swiperWrap'> 
          <div className='contentWrap'>   
          <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-6 col-md-6 col-9'>
            <h1>Streamlining operations, accelerating innovation</h1>
            {/* <p>We are passionate about bringing enterprise-level productivity, scalability, and security to small and medium businesses.</p> */}
            <Link to='/devOps-consulting-services' className='get_started mt-2'>Get Started</Link>
            </div>
          </div>
          </div>
          </div> 
        </div>     

  <picture>


  <source media="(max-width:576px)" srcSet={slidermb3} />
  <img className='img-fluid' src={slider3} alt="Flowers"/>
</picture>

      </SwiperSlide>

      <SwiperSlide>

<div className='swiperWrap'> 
  <div className='contentWrap'>   
  <div className='container'>
  <div className='row align-items-center'>
    <div className='col-lg-6 col-md-6 col-9'>
    <h1>Everything travel, powered by a single API.</h1>
    <p>Unlock the world with our travel API solutions.</p>
    <Link to='/digital-marketing' className='get_started mt-2'>Get Started</Link>
    </div>
  </div>
  </div>
  </div> 
</div>     

<picture>


<source media="(max-width:576px)" srcSet={slidermb4} />
<img className='img-fluid' src={slider4} alt="Flowers"/>
</picture>

</SwiperSlide>

      </Swiper>


      </section>
    </>

  )
}

export default SwiperSlider;